import React from 'react';

/**
 * 다국어 국기 아이콘 — Figma `icon/lang/*` 컴포넌트 기반
 *
 * @param {string} lang - 'KOR' | 'ENG' | 'CHN' | 'JPN' | 'SPA'
 * @param {number} size - 아이콘 크기 (default 18)
 * @param {string} className - 추가 클래스
 *
 * 사용 예: <FlagIcon lang="KOR" size={20} />
 */
const FLAG_MAP = {
  KOR: '/images/flags/korean.svg',
  ENG: '/images/flags/english.svg',
  CHN: '/images/flags/chinese.svg',
  JPN: '/images/flags/japanese.svg',
  SPA: '/images/flags/spanish.svg',
};

const FLAG_ALT = {
  KOR: '한국어',
  ENG: 'English',
  CHN: '中文',
  JPN: '日本語',
  SPA: 'Español',
};

export default function FlagIcon({ lang, size = 18, className = '' }) {
  const src = FLAG_MAP[lang];
  if (!src) return null;
  return (
    <img
      src={src}
      alt={FLAG_ALT[lang] || lang}
      width={size}
      height={size}
      className={`inline-block shrink-0 ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
